import React from "react";
import { Col, Row } from "react-bootstrap";
import verizonLogo from "../../Assets/Verizon_Communications-Logo.wine.svg";
import googleLogo from "../../Assets/1741929315954.gif";

function Experience() {
  const experiences = [

        {
      logo: googleLogo,
      title: "Cloud Engineer Trainee",
      company: "Google Cloud",
      date: "Aug 2024 – Sep 2024",
      tasks: [
        " Selected for a competitive Google Cloud (Facilitator & Innovator Program) awarded mentorship & credits to build enterprise solutions.",
        " Engineered the program's capstone project: a AI fraud detection system on GCP, achieving a ~35% reduction in detection latency.",
        " Validated skills by completing 100+ labs and earning 50+ Google Cloud skill badges in core domains.",
      ],
    },

    {
      logo: verizonLogo,
      title: "Cloud Engineer Intern",
      company: "Verizon",
      date: "Aug 2024 – Sep 2024",
      tasks: [
        "Designed and implemented a secure VPN solution to enhance remote connectivity.",
        "Applied cloud-native security principles including redundancy, resiliency, and least-privilege.",
        "Improved simulated cloud security by 45% by enforcing access policies.",
      ],
    },
    
  ];

  return (
    <>
      {experiences.map((exp, index) => (
        <Row
          key={index}
          className="experience-card align-items-center mb-5 p-4"
          style={{
            backgroundColor: "#1e1e2f",
            borderRadius: "20px",
            boxShadow: "0 0 20px rgba(199, 112, 240, 0.15)",
            color: "#fff",
            direction: "ltr", // تم إضافة هذا السطر
          }}
        >
          {/* Logo */}
          <Col md={3} className="text-center">
            <img
              src={exp.logo}
              alt={`${exp.company} logo`}
              style={{
                width: "200px",
                height: "auto",
                objectFit: "contain",
                borderRadius: "18px",
              }}
            />
          </Col>

          {/* Text Content */}
          <Col md={9}>
            <h4 style={{ color: "#c770f0", fontWeight: "bold" }}>{exp.title}</h4>
            <h5 className="mb-3" style={{ fontSize: "1.2rem" }}>
              {exp.company} | {exp.date}
            </h5>
            <ul style={{ fontSize: "1rem", paddingLeft: "20px", textAlign: "left" }}>
              {exp.tasks.map((task, idx) => (
                <li key={idx} style={{ marginBottom: "8px" }}>
                  {task}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      ))}
    </>
  );
}

export default Experience;